import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  AuthRequestOptions,
  BusinessItem,
  ItemView,
  ItemViewProviderDirective
} from '@ntap/core';
import { distinctUntilChanged, first, map, mergeMap, tap } from 'rxjs';

import { AppConfig, appConfigService } from '@app/config';

@Component({
  selector: 'app-sudski-registar-panel',
  templateUrl: './sudski-registar-panel.component.html',
  styleUrls: ['./sudski-registar-panel.component.scss']
})
export class SudskiRegistarPanelComponent {
  showDialog = false;
  sudskiRegistarResponseO: any = null;
  identifikator = new FormControl(null, [
    Validators.required,
    Validators.minLength(10),
    Validators.pattern('^[0-9]*$')
  ]);
  parrentFormData: any;
  dirty = false;
  applyError: any = null;
  fetchError: any = null;
  itemName$ = this.itemViewProviderDirective.item$.pipe(
    map(() => this.itemViewProviderDirective.viewName),
    distinctUntilChanged()
  );

  constructor(
    @Inject(appConfigService) private config: AppConfig,
    private http: HttpClient,
    private itemViewProviderDirective: ItemViewProviderDirective<ItemView>
  ) {
    this.itemViewProviderDirective.item$.subscribe((item) => {
      this.parrentFormData = item;
    });
  }

  doShowDialog(showDialog: boolean) {
    this.showDialog = showDialog;
    this.applyError = null;
    this.fetchError = null;
    this.dirty = false;
    this.sudskiRegistarResponseO = null;
  }

  apply() {
    const currentNaziv = this.parrentFormData['en~agent~naziv'];
    let response = null;
    if (currentNaziv != null && currentNaziv != undefined) {
      this.itemViewProviderDirective.commitItem();
      response = this.itemViewProviderDirective.item$.pipe(
        first(),
        mergeMap((item) => {
          return this.itemViewProviderDirective
            .save(new BusinessItem(item))
            .pipe(
              mergeMap(() => {
                return this.saveDataFromRegistar();
              })
            );
        })
      );
    } else {
      response = this.saveDataFromRegistar();
    }
    response.subscribe({
      next: () => {
        this.showDialog = false;
        this.itemViewProviderDirective.viewState = Object.assign(
          { ...this.itemViewProviderDirective.viewState },
          { 'en~agent~id': this.parrentFormData['en~agent~id'] }
        );
      },
      error: () => {
        this.applyError = 'Greška kod spremanja podataka!';
      }
    });
  }
  saveDataFromRegistar() {
    return this.http
      .post(
        this.config.apiHost +
          'sregistar' +
          `/${this.parrentFormData['en~agent~id']}` +
          `/${this.identifikator.value}`,
        null,
        new AuthRequestOptions()
      )
      .pipe(
        tap(() => {
          this.applyError = null;
        })
      );
  }

  onSubmit() {
    return this.http
      .get(this.config.apiHost + 'sregistar/' + `${this.identifikator.value}`, {
        observe: 'response',
        responseType: 'json'
      })
      .pipe(
        tap(() => {
          this.applyError = null;
          this.fetchError = null;
        }),
        map((response: any) => {
          return response.body;
        })
      )
      .subscribe({
        next: (v) => {
          this.dirty = true;
          this.sudskiRegistarResponseO = v;
        },
        error: (e) => {
          this.fetchError =
            e.error.message || e.message || 'Greška kod dohvata podataka!';
        }
      });
  }
}
